<template>
	<!-- <content-head title="Home" /> -->
	<heading />
	<content class="">
		<div class="row">
			<!-- Loading Overlay for Modal Data -->
			<div v-if="loadModalData" class="loading-overlay">
				<div class="loading-spinner">
					<div class="spinner-border text-primary" role="status">
						<span class="visually-hidden">Loading ...</span>
					</div>
					<p class="mt-3">Loading Data ...</p>
				</div>
			</div>
			<div
				class="card custom-card bg-light col-xl-12 rounded-0 border-0 shadow"
			>
				<div class="row card-title pb-0 px-2 pt-2">
					<div class="col-12">
						<div
							class="page-title-box d-sm-flex align-items-center justify-content-between nunito-black"
						>
							<div class="page-title-left">
								<ol class="breadcrumb m-0">
									<li class="breadcrumb-item">
										<a href="">
											<span
												class="badge rounded-pill bg-green-custom text-white font-size-15"
												>&nbsp;&nbsp;&nbsp;<i
													class="nav-icon fas fa-handshake"
												></i
												>&nbsp;&nbsp;Reservation&nbsp;&nbsp;&nbsp;</span
											>
										</a>
									</li>

									<li class="active">&nbsp;&nbsp;Tour Costing&nbsp;&nbsp;</li>
								</ol>
							</div>
						</div>
					</div>
				</div>

				<div class="row card-body mt-0 pt-0">
					<div class="row">
						<div class="col-xl-12">
							<div class="card card-body p-4 text-dark">
								<div class="row mb-1 d-flex p-2">
									<div class="col-md-12">
										<div class="mb-1">
											<label for="agent_id" class="form-label"
												>Select Registered Tour</label
											>
											<v-autocomplete
												density="compact"
												variant="outlined"
												rounded="0"
												return-object
												placeholder="Select Registerd Tour"
												:items="this.infiniteTours.data"
												v-model="filterCosting.tour"
												@update:modelValue="selectTour($event)"
												:item-title="tourSelect"
												item-value="id"
												clearable
											>
											</v-autocomplete>
										</div>
									</div>
									<div
										class="col-md-3 justify-content-start align-items-center gap-2 d-none"
										style="font-family: HeaderCustomFont"
									>
										<button
											type="submit"
											id="Filter"
											class="btn btn-info rounded-0 text-white"
										>
											<i class="nav-icon fas fa-filter"></i>&nbsp;&nbsp;Filter
										</button>
										<button
											type="button"
											id="Export"
											class="btn btn-danger rounded-0 text-white"
										>
											<i class="nav-icon fas fa-window-close"></i
											>&nbsp;&nbsp;Clear
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="row card-body mt-0 p-4">
					<div class="row">
						<div class="col-xl-12">
							<v-expansion-panels v-model="openPanels.tourPricing">
								<v-expansion-panel expand>
									<v-expansion-panel-title
										density="compact"
										class="compact-header text-dark rounded-0"
									>
										Tour Pricing
									</v-expansion-panel-title>
									<v-expansion-panel-text>
										<div class="card card-body accordion-body text-dark">
											<div class="row col-sm-12">
												<div class="col-sm-7 float-sm-left text-start"></div>
												<div
													class="col-sm-5 text-end"
													style="font-family: HeaderCustomFont"
												>
													<button
														:disabled="!currentRoute"
														data-toggle="tooltip"
														data-placement="top"
														title="Define an itinerary to start costing"
														class="btn text-none bg-green-custom float-sm-right text-white rounded-0"
														@click="openModal('pricing')"
													>
														<i class="nav-icon fas fa-plus"></i>&nbsp;&nbsp;Tour
														Pricing
													</button>
												</div>
											</div>
											<div class="row col-sm-12 mt-2">
												<div class="table-responsive p-1">
													<v-text-field
														v-model="searchPricing"
														label="Search Tour Guests"
														prepend-inner-icon="mdi-magnify"
														flat
														rounded="0"
														variant="outlined"
														density="compact"
														class="d-none"
													></v-text-field>
													<v-data-table
														v-model:items-per-page="pricingPerPage"
														:headers="pricingHeaders"
														:items="pricings.data"
														:search="searchPricing"
														density="compact"
														item-value="name"
														class="table-sm table-striped rounded-0 text-truncate table-nowrap"
													>
														<template v-slot:body="{ items }">
															<tr
																v-for="(item, index) in items.filter(
																	(item) => item.cost_kind == 'Internal'
																)"
																:key="item.id"
															>
																<td>{{ index + 1 }}</td>
																<td>
																	{{ item.type ? item.type.name : null }}
																</td>
																<!-- <td>{{ item.cost_detail }}</td> -->
																<td v-if="item.item">{{ item.item.name }}</td>
																<td v-else-if="item.park">
																	{{ item.park.name }}
																</td>
																<td v-else-if="item.lodge">
																	{{ item.lodge.name }}
																</td>
																<td v-else-if="item.vehicle">
																	{{ item.vehicle.vehicle_type }}
																</td>
																<td v-else>
																	{{
																		item.activity ? item.activity.title : null
																	}}
																</td>
																<td>{{ item.unit_cost }}</td>
																<td>{{ item.qty }}</td>
																<td>{{ item.total }}</td>
																<td class="">
																	<v-menu v-if="currentRoute" offset-y>
																		<template v-slot:activator="{ props }">
																			<v-icon v-bind="props" size="24">
																				mdi-dots-horizontal
																			</v-icon>
																		</template>

																		<v-list
																			density="compact"
																			class="custom-dropdown"
																		>
																			<v-list-item
																				@click="managePricing(item, 'edit')"
																			>
																				<v-list-item-title
																					><font-awesome-icon
																						icon="fa-regular fa-pen-to-square"
																					/>&nbsp;&nbsp;&nbsp;&nbsp;Edit</v-list-item-title
																				>
																			</v-list-item>
																			<v-list-item
																				@click="managePricing(item, 'delete')"
																			>
																				<v-list-item-title
																					><font-awesome-icon
																						icon="fa-solid fa-trash"
																					/>&nbsp;&nbsp;&nbsp;&nbsp;Delete</v-list-item-title
																				>
																			</v-list-item>
																		</v-list>
																	</v-menu>
																</td>
															</tr>
														</template>
														<template v-slot:body.append="{ items }">
															<tr
																class="font-weight-bold"
																style="font-family: HeaderCustomFont"
															>
																<td colspan="5" class="text-end">
																	Quote Total
																</td>
																<td>
																	{{
																		formatCurrency(
																			items
																				.filter(
																					(item) => item.cost_kind == "Internal"
																				)
																				.reduce(
																					(sum, item) =>
																						sum + Number(item.total || 0),
																					0
																				),
																			"",
																			2
																		)
																	}}
																</td>
																<td></td>
															</tr>
														</template>
													</v-data-table>
												</div>
											</div>
										</div>
									</v-expansion-panel-text>
								</v-expansion-panel>
							</v-expansion-panels>
							<!-- </div> -->
							<!-- </div> -->
						</div>
					</div>
				</div>

				<div class="row card-body mt-0 p-4">
					<div class="row">
						<div class="col-xl-12">
							<v-expansion-panels v-model="openPanels.optionalCosts">
								<v-expansion-panel expand>
									<v-expansion-panel-title
										density="compact"
										class="compact-header text-dark rounded-0"
									>
										Optional Costs
									</v-expansion-panel-title>
									<v-expansion-panel-text>
										<div class="card card-body accordion-body text-dark">
											<div class="row col-sm-12">
												<div class="col-sm-7 float-sm-left text-start"></div>
												<div
													class="col-sm-5 text-end"
													style="font-family: HeaderCustomFont"
												>
													<button
														:disabled="!currentRoute"
														class="btn text-none bg-green-custom float-sm-right text-white rounded-0 d-none"
														@click="openModal('pricing')"
													>
														<i class="nav-icon fas fa-plus"></i
														>&nbsp;&nbsp;Optional Costs
													</button>
												</div>
											</div>
											<div class="row col-sm-12 mt-2">
												<div class="table-responsive p-1">
													<v-text-field
														v-model="searchCost"
														label="Search Tour Costs"
														prepend-inner-icon="mdi-magnify"
														flat
														rounded="0"
														variant="outlined"
														density="compact"
														class="d-none"
													></v-text-field>
													<v-data-table
														v-model:items-per-page="pricingPerPage"
														:headers="pricingHeaders"
														:items="pricings.data"
														:search="searchPricing"
														density="compact"
														item-value="name"
														class="table-sm table-striped rounded-0 text-truncate table-nowrap"
													>
														<template v-slot:body="{ items }">
															<tr
																v-for="(item, index) in items.filter(
																	(item) => item.cost_kind == 'Optional'
																)"
																:key="item.id"
															>
																<td>{{ index + 1 }}</td>
																<td>
																	{{ item.type ? item.type.name : null }}
																</td>
																<!-- <td>{{ item.cost_detail }}</td> -->
																<td v-if="item.item">{{ item.item.name }}</td>
																<td v-else-if="item.park">
																	{{ item.park.name }}
																</td>
																<td v-else-if="item.lodge">
																	{{ item.lodge.name }}
																</td>
																<td v-else-if="item.vehicle">
																	{{ item.vehicle.vehicle_type }}
																</td>
																<td v-else>
																	{{
																		item.activity
																			? item.activity.activity_name
																			: item.cost_detail
																	}}
																</td>
																<td>{{ item.unit_cost }}</td>
																<td>{{ item.qty }}</td>
																<td>{{ item.total }}</td>
																<td class="">
																	<v-menu v-if="currentRoute" offset-y>
																		<template v-slot:activator="{ props }">
																			<v-icon v-bind="props" size="24">
																				mdi-dots-horizontal
																			</v-icon>
																		</template>

																		<v-list
																			density="compact"
																			class="custom-dropdown"
																		>
																			<v-list-item
																				@click="managePricing(item, 'edit')"
																			>
																				<v-list-item-title
																					><font-awesome-icon
																						icon="fa-regular fa-pen-to-square"
																					/>&nbsp;&nbsp;&nbsp;&nbsp;Edit</v-list-item-title
																				>
																			</v-list-item>
																			<v-list-item
																				@click="managePricing(item, 'delete')"
																			>
																				<v-list-item-title
																					><font-awesome-icon
																						icon="fa-solid fa-trash"
																					/>&nbsp;&nbsp;&nbsp;&nbsp;Delete</v-list-item-title
																				>
																			</v-list-item>
																		</v-list>
																	</v-menu>
																</td>
															</tr>
														</template>
														<template v-slot:body.append="{ items }">
															<tr
																class="font-weight-bold"
																style="font-family: HeaderCustomFont"
															>
																<td colspan="5" class="text-end">
																	Options Total
																</td>
																<td>
																	{{
																		formatCurrency(
																			items
																				.filter(
																					(item) => item.cost_kind == "Optional"
																				)
																				.reduce(
																					(sum, item) =>
																						sum + Number(item.total || 0),
																					0
																				),
																			"",
																			2
																		)
																	}}
																</td>
																<td></td>
															</tr>
														</template>
													</v-data-table>
												</div>
											</div>
										</div>
									</v-expansion-panel-text>
								</v-expansion-panel>
							</v-expansion-panels>
							<!-- </div> -->
							<!-- </div> -->
						</div>
					</div>
				</div>

				<div class="row card-body mt-0 p-4">
					<div class="row">
						<div class="col-xl-12">
							<v-expansion-panels v-model="openPanels.adminFees">
								<v-expansion-panel expand>
									<v-expansion-panel-title
										density="compact"
										class="compact-header text-dark rounded-0"
									>
										Administrative Fees
									</v-expansion-panel-title>
									<v-expansion-panel-text>
										<div class="card card-body accordion-body text-dark">
											<div class="row col-sm-12">
												<div class="col-sm-7 float-sm-left text-start"></div>
												<div
													class="col-sm-5 text-end"
													style="font-family: HeaderCustomFont"
												>
													<button
														:disabled="!currentRoute"
														v-if="this.pricings"
														class="btn text-none bg-green-custom float-sm-right text-white rounded-0"
														@click="openModal('admin')"
													>
														<i class="nav-icon fas fa-plus"></i
														>&nbsp;&nbsp;Admin Fees
													</button>
												</div>
											</div>
											<div class="row col-sm-12 mt-2">
												<div class="table-responsive p-1">
													<v-text-field
														v-model="searchAdmin"
														label="Search Tour Costs"
														prepend-inner-icon="mdi-magnify"
														flat
														rounded="0"
														variant="outlined"
														density="compact"
														class="d-none"
													></v-text-field>
													<v-data-table
														v-model:items-per-page="adminPerPage"
														:headers="adminHeaders"
														:items="adminFees.data"
														:search="searchAdmin"
														density="compact"
														item-value="name"
														class="table-sm table-striped rounded-0 text-truncate table-nowrap"
													>
														<template v-slot:body="{ items }">
															<tr v-for="(item, index) in items" :key="item.id">
																<td>{{ index + 1 }}</td>
																<td>
																	{{ item.admin_fee }}
																</td>
																<td>
																	{{ item.multiplier }}
																</td>
																<td>
																	{{ item.total_fee }}
																</td>
																<td class="">
																	<v-menu v-if="currentRoute" offset-y>
																		<template v-slot:activator="{ props }">
																			<v-icon v-bind="props" size="24">
																				mdi-dots-horizontal
																			</v-icon>
																		</template>

																		<v-list
																			density="compact"
																			class="custom-dropdown"
																		>
																			<v-list-item
																				@click="manageAdmin(item, 'edit')"
																			>
																				<v-list-item-title
																					><font-awesome-icon
																						icon="fa-regular fa-pen-to-square"
																					/>&nbsp;&nbsp;&nbsp;&nbsp;Edit</v-list-item-title
																				>
																			</v-list-item>
																			<v-list-item
																				@click="manageAdmin(item, 'delete')"
																			>
																				<v-list-item-title
																					><font-awesome-icon
																						icon="fa-solid fa-trash"
																					/>&nbsp;&nbsp;&nbsp;&nbsp;Delete</v-list-item-title
																				>
																			</v-list-item>
																		</v-list>
																	</v-menu>
																</td>
															</tr>
														</template>
													</v-data-table>
												</div>
											</div>
										</div>
									</v-expansion-panel-text>
								</v-expansion-panel>
							</v-expansion-panels>
							<!-- </div> -->
							<!-- </div> -->
						</div>
					</div>
				</div>

				<div class="row card-body mt-0 p-4">
					<div class="row">
						<div class="col-xl-12">
							<v-expansion-panels v-model="openPanels.personBreakdown">
								<v-expansion-panel expand>
									<v-expansion-panel-title
										density="compact"
										class="compact-header text-dark rounded-0"
									>
										Per Person Breakdown
									</v-expansion-panel-title>
									<v-expansion-panel-text>
										<div class="card card-body accordion-body text-dark">
											<div class="row col-sm-12">
												<div class="col-sm-7 float-sm-left text-start"></div>
												<div
													class="col-sm-5 text-end"
													style="font-family: HeaderCustomFont"
												>
													<button
														:disabled="!currentRoute"
														v-if="this.pricings"
														class="btn text-none bg-green-custom float-sm-right text-white rounded-0"
														@click="openModal('breakdown')"
													>
														<i class="nav-icon fas fa-plus"></i
														>&nbsp;&nbsp;Breakdown
													</button>
												</div>
											</div>
											<div class="row col-sm-12 mt-2">
												<div class="table-responsive p-1">
													<v-text-field
														v-model="searchBreakdown"
														label="Search Tour Costs"
														prepend-inner-icon="mdi-magnify"
														flat
														rounded="0"
														variant="outlined"
														density="compact"
														class="d-none"
													></v-text-field>
													<v-data-table
														v-model:items-per-page="breakdownPerPage"
														:headers="breakdownHeaders"
														:items="personBreakdowns.data"
														:search="searchBreakdown"
														density="compact"
														item-value="name"
														class="table-sm table-striped rounded-0 text-truncate table-nowrap"
													>
														<template v-slot:body="{ items }">
															<tr v-for="(item, index) in items" :key="item.id">
																<td>{{ index + 1 }}</td>
																<td>
																	{{ item.first_total }}
																</td>
																<td>
																	{{ item.second_total }}
																</td>
																<td>
																	{{
																		parseFloat(
																			parseFloat(item.first_total) +
																				parseFloat(item.second_total)
																		).toFixed(2)
																	}}
																</td>
																<td>
																	{{ item.pax }}
																</td>
																<td class="">
																	<v-menu v-if="currentRoute" offset-y>
																		<template v-slot:activator="{ props }">
																			<v-icon v-bind="props" size="24">
																				mdi-dots-horizontal
																			</v-icon>
																		</template>

																		<v-list
																			density="compact"
																			class="custom-dropdown"
																		>
																			<v-list-item
																				@click="manageBreakdown(item, 'edit')"
																			>
																				<v-list-item-title
																					><font-awesome-icon
																						icon="fa-regular fa-pen-to-square"
																					/>&nbsp;&nbsp;&nbsp;&nbsp;Edit</v-list-item-title
																				>
																			</v-list-item>
																			<v-list-item
																				@click="manageBreakdown(item, 'delete')"
																			>
																				<v-list-item-title
																					><font-awesome-icon
																						icon="fa-solid fa-trash"
																					/>&nbsp;&nbsp;&nbsp;&nbsp;Delete</v-list-item-title
																				>
																			</v-list-item>
																		</v-list>
																	</v-menu>
																</td>
															</tr>
														</template>
													</v-data-table>
												</div>
											</div>
										</div>
									</v-expansion-panel-text>
								</v-expansion-panel>
							</v-expansion-panels>
							<!-- </div> -->
							<!-- </div> -->
						</div>
					</div>
				</div>
			</div>

			<v-dialog v-model="pricingModal" max-width="1000px" persistent>
				<v-card>
					<form
						@submit.prevent="
							editMode
								? managePricing(this.tourPricing, 'update')
								: managePricing(this.tourPricing, 'insert')
						"
					>
						<v-card-title class="d-flex justify-space-between align-center">
							<div class="modal-header">
								<!-- <slot name="header">default header</slot> -->
								<h5
									class="modal-title font-size-20 text-dark"
									style="font-family: HeaderCustomFont"
								>
									<font-awesome-icon icon="fas fa-handshake" />&nbsp;&nbsp;Tour
									Costing
								</h5>
							</div>
							<v-icon @click="closeModal('pricing')">mdi-close</v-icon>
						</v-card-title>
						<!-- Dialog Content -->
						<v-card-text>
							<div class="modal-body p-4">
								<div
									id="preloader d-none"
									class="col-sm-2 p-5"
									v-if="this.processing"
								>
									<div id="status">
										<div class="spinner-chase text-start">
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
										</div>
									</div>
								</div>
								<div class="text-start">
									<div class="row mt-1">
										<div class="col-md-3">
											<label for="cost_kind" class="form-label"
												><span
													v-if="tourPricing.errors.has('cost_kind')"
													class="text-danger text-lowercase"
												>
													{{ tourPricing.errors.get("cost_kind") }} </span
												><span v-else>Internal/Optional</span></label
											>
											<v-select
												density="compact"
												variant="outlined"
												rounded="0"
												clearable
												placeholder="Select Cost Type"
												:items="['Internal', 'Optional']"
												v-model="tourPricing.cost_kind"
												id="cost_kind"
											>
											</v-select>
										</div>
										<div class="col-md-3 required">
											<label for="cost_type_id" class="form-label"
												><span
													v-if="tourPricing.errors.has('cost_type_id')"
													class="text-danger text-lowercase"
												>
													{{ tourPricing.errors.get("cost_type_id") }} </span
												><span v-else>Cost Category</span></label
											>
											<v-autocomplete
												density="compact"
												variant="outlined"
												rounded="0"
												return-object
												placeholder="Select Cost Category"
												:items="
													this.infiniteTypes.data.filter(
														(type) => type.tour_cost !== 'No'
													)
												"
												v-model="tourPricing.cost_type_id"
												@update:modelValue="tourPricing.cost_detail = ''"
												item-value="id"
												item-title="name"
												id="cost_type_id"
											>
											</v-autocomplete>
										</div>
										<template v-if="tourPricing.cost_kind !== 'Optional'">
											<div
												class="col-md-6 required"
												v-if="
													tourPricing.cost_type_id &&
													tourPricing.cost_type_id.code == 'PE'
												"
											>
												<label for="park_id" class="form-label"
													><span
														v-if="tourPricing.errors.has('park_id')"
														class="text-danger text-lowercase"
													>
														{{ tourPricing.errors.get("park_id") }} </span
													><span v-else>National Park</span></label
												>
												<v-autocomplete
													density="compact"
													variant="outlined"
													rounded="0"
													clearable
													return-object
													placeholder="Select National Park"
													:items="this.infiniteParks.data"
													v-model="tourPricing.park_id"
													@update:modelValue="selectItem($event, 'park')"
													item-value="id"
													:item-title="
														(item) => (item.park ? item.park.name : 'None')
													"
													id="park_id"
												>
												</v-autocomplete>
											</div>
											<div
												class="col-md-6 required"
												v-else-if="
													tourPricing.cost_type_id &&
													tourPricing.cost_type_id.code == 'TR'
												"
											>
												<label for="vehicle_id" class="form-label"
													><span
														v-if="tourPricing.errors.has('vehicle_id')"
														class="text-danger text-lowercase"
													>
														{{ tourPricing.errors.get("vehicle_id") }} </span
													><span v-else>Tour Vehicle</span></label
												>
												<v-autocomplete
													density="compact"
													variant="outlined"
													rounded="0"
													clearable
													return-object
													placeholder="Select Tour Vehicle"
													:items="this.infiniteVehicles.data"
													v-model="tourPricing.vehicle_id"
													@update:modelValue="selectItem($event, 'vehicle')"
													item-value="id"
													:item-title="
														(item) =>
															item.vehicle ? item.vehicle.vehicle_type : 'None'
													"
													id="vehicle_id"
												>
												</v-autocomplete>
											</div>
											<div
												class="col-md-6 required"
												v-else-if="
													tourPricing.cost_type_id &&
													tourPricing.cost_type_id.code == 'ACC'
												"
											>
												<label for="lodge_id" class="form-label"
													><span
														v-if="tourPricing.errors.has('lodge_id')"
														class="text-danger text-lowercase"
													>
														{{ tourPricing.errors.get("lodge_id") }} </span
													><span v-else>Tour Accomodation</span></label
												>
												<v-autocomplete
													density="compact"
													variant="outlined"
													rounded="0"
													clearable
													return-object
													placeholder="Select Tour Accomodation"
													:items="this.infiniteLodges.data"
													v-model="tourPricing.lodge_id"
													@update:modelValue="selectItem($event, 'lodge')"
													item-value="id"
													:item-title="
														(item) => (item.lodge ? item.lodge.name : 'None')
													"
													id="lodge_id"
												>
												</v-autocomplete>
											</div>
											<div
												class="col-md-6 required"
												v-else-if="
													tourPricing.cost_type_id &&
													tourPricing.cost_type_id.code == 'ACT'
												"
											>
												<label for="activity_id" class="form-label"
													><span
														v-if="tourPricing.errors.has('activity_id')"
														class="text-danger text-lowercase"
													>
														{{ tourPricing.errors.get("activity_id") }} </span
													><span v-else>Tour Activity</span></label
												>
												<v-autocomplete
													density="compact"
													variant="outlined"
													rounded="0"
													clearable
													return-object
													placeholder="Select Tour Activity"
													:items="this.infiniteActivities.data"
													v-model="tourPricing.activity_id"
													@update:modelValue="selectItem($event, 'activity')"
													item-value="id"
													item-title="itinerary_title"
													id="activity_id"
												>
												</v-autocomplete>
											</div>
											<div
												class="col-md-6 required"
												v-else-if="
													tourPricing.cost_type_id &&
													tourPricing.cost_type_id.code == 'BR'
												"
											>
												<label for="activity_id" class="form-label"
													><span
														v-if="tourPricing.errors.has('activity_id')"
														class="text-danger text-lowercase"
													>
														{{ tourPricing.errors.get("activity_id") }} </span
													><span v-else>Tour Boats</span></label
												>
												<v-autocomplete
													density="compact"
													variant="outlined"
													rounded="0"
													clearable
													return-object
													placeholder="Select Tour Boat"
													:items="this.infiniteBoats.data"
													v-model="tourPricing.boat_id"
													@update:modelValue="selectItem($event, 'boat')"
													item-value="id"
													:item-title="
														(item) => (item.boat ? item.boat.name : 'None')
													"
													id="boat_id"
												>
												</v-autocomplete>
											</div>
											<div
												class="col-md-6 required"
												v-else-if="
													tourPricing.cost_type_id &&
													tourPricing.cost_type_id.code == 'FL'
												"
											>
												<label for="activity_id" class="form-label"
													><span
														v-if="tourPricing.errors.has('activity_id')"
														class="text-danger text-lowercase"
													>
														{{ tourPricing.errors.get("activity_id") }} </span
													><span v-else>Tour Flights</span></label
												>
												<v-autocomplete
													density="compact"
													variant="outlined"
													rounded="0"
													clearable
													return-object
													placeholder="Select Tour Flight"
													:items="this.infiniteFlights.data"
													v-model="tourPricing.flight_id"
													@update:modelValue="selectItem($event, 'flight')"
													item-value="id"
													:item-title="
														(item) => (item.flight ? item.flight.name : 'None')
													"
													id="flight_id"
												>
												</v-autocomplete>
											</div>
											<div v-else class="col-md-6 required">
												<label for="cost_item_id" class="form-label"
													><span
														v-if="tourPricing.errors.has('cost_item_id')"
														class="text-danger text-lowercase"
													>
														{{ tourPricing.errors.get("cost_item_id") }} </span
													><span v-else>Pricing Item</span></label
												>
												<v-autocomplete
													density="compact"
													variant="outlined"
													rounded="0"
													clearable
													return-object
													placeholder="Select Price Category"
													:items="this.infiniteItems.data"
													v-model="tourPricing.cost_item_id"
													@update:modelValue="selectItem($event, 'other')"
													item-value="id"
													item-title="name"
													id="cost_item_id"
												>
												</v-autocomplete>
											</div>
										</template>
									</div>
									<div class="row mt-1">
										<div class="col-md-12 required">
											<label for="cost_detail" class="form-label"
												><span
													v-if="tourPricing.errors.has('cost_detail')"
													class="text-danger text-lowercase"
												>
													{{ tourPricing.errors.get("cost_detail") }} </span
												><span v-else>Pricing Particulars</span></label
											>
											<v-text-field
												density="compact"
												variant="outlined"
												rounded="0"
												clearable
												placeholder="Select Pricing Item"
												v-model="tourPricing.cost_detail"
												id="cost_detail"
											></v-text-field>
										</div>
									</div>
									<div class="row mt-1">
										<div class="col-md-3">
											<label for="name" class="form-label"
												><span
													v-if="tourPricing.errors.has('unit_cost')"
													class="text-danger text-lowercase"
												>
													{{ tourPricing.errors.get("unit_cost") }} </span
												><span v-else>Unit Cost</span></label
											>
											<v-text-field
												density="compact"
												variant="outlined"
												rounded="0"
												clearable
												placeholder="Unit Cost"
												v-model="tourPricing.unit_cost"
												id="unit_cost"
											></v-text-field>
										</div>
										<div class="col-md-4">
											<label for="currency" class="form-label"
												><span
													v-if="tourPricing.errors.has('currency')"
													class="text-danger text-lowercase"
												>
													{{ tourPricing.errors.get("currency") }} </span
												><span v-else>Currency</span></label
											>
											<!-- @update:modelValue="tourPricing.cost_detail = ''" -->
											<v-autocomplete
												density="compact"
												variant="outlined"
												rounded="0"
												return-object
												placeholder="Select Currency"
												:items="this.currencyList.data"
												v-model="tourPricing.currency"
												item-value="symbol"
												item-title="currency"
												id="currency"
											>
											</v-autocomplete>
										</div>
										<div class="col-md-2">
											<label for="qty" class="form-label"
												><span
													v-if="tourPricing.errors.has('qty')"
													class="text-danger text-lowercase"
												>
													{{ tourPricing.errors.get("qty") }} </span
												><span v-else>Quantity/Pax</span></label
											>
											<v-text-field
												density="compact"
												variant="outlined"
												rounded="0"
												clearable
												placeholder="Number of Pax"
												v-model="tourPricing.qty"
												id="qty"
											></v-text-field>
										</div>
										<div
											class="col-md-3"
											v-if="
												tourPricing.cost_type_id &&
												tourPricing.cost_type_id.code == 'ACC'
											"
										>
											<label for="days_nights" class="form-label"
												><span
													v-if="tourPricing.errors.has('days_nights')"
													class="text-danger text-lowercase"
												>
													{{ tourPricing.errors.get("days_nights") }} </span
												><span v-else>Days/Nights</span></label
											>
											<v-text-field
												density="compact"
												variant="outlined"
												rounded="0"
												clearable
												placeholder="Days/Nights"
												v-model="tourPricing.days_nights"
												id="days_nights"
											></v-text-field>
										</div>
									</div>
								</div>
							</div>
						</v-card-text>

						<!-- Footer with Action Buttons -->
						<v-card-actions>
							<v-spacer>
								<!-- end of modal body -->
								<div
									class="justify-content-start modal-footer"
									style="font-family: HeaderCustomFont"
								>
									<button
										:disabled="!currentRoute"
										type="submit"
										class="btn bg-green-custom text-white w-10 m-2"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Save Tour
									</button>
									<button
										type="button"
										class="btn bg-danger text-white w-10 m-2"
										@click="closeModal('pricing')"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Close
									</button>
								</div>
							</v-spacer>
							<!-- <v-btn color="primary" @click="tourModal = false">Close</v-btn> -->
						</v-card-actions>
					</form>
				</v-card>
			</v-dialog>

			<v-dialog v-model="adminModal" max-width="1000px" persistent>
				<v-card>
					<form
						@submit.prevent="
							editMode
								? manageAdmin(this.adminFee, 'update')
								: manageAdmin(this.adminFee, 'insert')
						"
					>
						<v-card-title class="d-flex justify-space-between align-center">
							<div class="modal-header">
								<!-- <slot name="header">default header</slot> -->
								<h5
									class="modal-title font-size-20 text-dark"
									style="font-family: HeaderCustomFont"
								>
									<font-awesome-icon icon="fas fa-handshake" />&nbsp;&nbsp;Admin
									Fees
								</h5>
							</div>
							<v-icon @click="closeModal('admin')">mdi-close</v-icon>
						</v-card-title>
						<!-- Dialog Content -->
						<v-card-text>
							<div class="modal-body p-4">
								<div
									id="preloader d-none"
									class="col-sm-2 p-5"
									v-if="this.processing"
								>
									<div id="status">
										<div class="spinner-chase text-start">
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
										</div>
									</div>
								</div>
								<div class="text-start">
									<div class="row mt-1">
										<div class="col-md-4 required">
											<label for="name" class="form-label"
												><span
													v-if="adminFee.errors.has('admin_fee')"
													class="text-danger text-lowercase"
												>
													{{ adminFee.errors.get("admin_fee") }} </span
												><span v-else>Administrative Percentage</span></label
											>
											<v-text-field
												density="compact"
												variant="outlined"
												rounded="0"
												clearable
												placeholder="Admin Percentage"
												v-model="adminFee.admin_fee"
												id="admin_fee"
											></v-text-field>
										</div>
										<div class="col-md-6 required">
											<div class="">
												<label for="name" class="form-label"
													><span
														v-if="adminFee.errors.has('multiplier')"
														class="text-danger text-lowercase"
													>
														{{ adminFee.errors.get("multiplier") }} </span
													><span v-else
														>Multiplier (Transport, Accomodation, Activities
														Costs)</span
													></label
												>
												<v-text-field
													density="compact"
													variant="outlined"
													rounded="0"
													clearable
													disabled
													placeholder="Transport, Accomodation, Activities Total Costs"
													v-model="adminFee.multiplier"
													id="multiplier"
												></v-text-field>
											</div>
										</div>
									</div>
								</div>
							</div>
						</v-card-text>

						<!-- Footer with Action Buttons -->
						<v-card-actions>
							<v-spacer>
								<!-- end of modal body -->
								<div
									class="justify-content-start modal-footer"
									style="font-family: HeaderCustomFont"
								>
									<button
										:disabled="!currentRoute"
										type="submit"
										class="btn bg-green-custom text-white w-10 m-2"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Save
									</button>
									<button
										type="button"
										class="btn bg-danger text-white w-10 m-2"
										@click="closeModal('admin')"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Close
									</button>
								</div>
							</v-spacer>
							<!-- <v-btn color="primary" @click="tourModal = false">Close</v-btn> -->
						</v-card-actions>
					</form>
				</v-card>
			</v-dialog>

			<v-dialog v-model="breakdownModal" max-width="1000px" persistent>
				<v-card>
					<form
						@submit.prevent="
							editMode
								? manageBreakdown(this.personBreakdown, 'update')
								: manageBreakdown(this.personBreakdown, 'insert')
						"
					>
						<v-card-title class="d-flex justify-space-between align-center">
							<div class="modal-header">
								<!-- <slot name="header">default header</slot> -->
								<h5
									class="modal-title font-size-20 text-dark"
									style="font-family: HeaderCustomFont"
								>
									<font-awesome-icon
										icon="fas fa-handshake"
									/>&nbsp;&nbsp;Person Breakdown
								</h5>
							</div>
							<v-icon @click="closeModal('breakdown')">mdi-close</v-icon>
						</v-card-title>
						<!-- Dialog Content -->
						<v-card-text>
							<div class="modal-body p-4">
								<div
									id="preloader d-none"
									class="col-sm-2 p-5"
									v-if="this.processing"
								>
									<div id="status">
										<div class="spinner-chase text-start">
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
										</div>
									</div>
								</div>
								<div class="text-start">
									<div class="row mt-1">
										<div class="col-md-6 required">
											<label for="name" class="form-label"
												><span
													v-if="personBreakdown.errors.has('first_amount')"
													class="text-danger text-lowercase"
												>
													{{
														personBreakdown.errors.get("first_amount")
													}} </span
												><span v-else
													>Total (Transport, Administrative Fees)</span
												></label
											>
											<v-text-field
												density="compact"
												variant="outlined"
												rounded="0"
												clearable
												disabled
												placeholder="Transport, Admin Total Costs"
												v-model="personBreakdown.first_amount"
												id="first_amount"
											></v-text-field>
										</div>
										<div class="col-md-4 required">
											<div class="">
												<label for="name" class="form-label"
													><span
														v-if="personBreakdown.errors.has('first_diviser')"
														class="text-danger text-lowercase"
													>
														{{
															personBreakdown.errors.get("first_diviser")
														}} </span
													><span v-else>First Diviser</span></label
												>
												<v-text-field
													density="compact"
													variant="outlined"
													rounded="0"
													clearable
													placeholder="First Diviser (Pax)"
													v-model="personBreakdown.first_diviser"
													id="first_diviser"
												></v-text-field>
											</div>
										</div>
									</div>
									<div class="row mt-1">
										<div class="col-md-6 required">
											<label for="name" class="form-label"
												><span
													v-if="personBreakdown.errors.has('second_amount')"
													class="text-danger text-lowercase"
												>
													{{
														personBreakdown.errors.get("second_amount")
													}} </span
												><span v-else
													>Total (Accomodation, Activities Fees)</span
												></label
											>
											<v-text-field
												density="compact"
												variant="outlined"
												rounded="0"
												clearable
												disabled
												placeholder="Accomodation, Activities Total Costs"
												v-model="personBreakdown.second_amount"
												id="second_amount"
											></v-text-field>
										</div>
										<div class="col-md-3 required">
											<div class="">
												<label for="name" class="form-label"
													><span
														v-if="personBreakdown.errors.has('second_diviser')"
														class="text-danger text-lowercase"
													>
														{{
															personBreakdown.errors.get("second_diviser")
														}} </span
													><span v-else>Second Diviser</span></label
												>
												<v-text-field
													density="compact"
													variant="outlined"
													rounded="0"
													clearable
													placeholder="Second Diviser"
													v-model="personBreakdown.second_diviser"
													id="second_diviser"
												></v-text-field>
											</div>
										</div>
										<div class="col-md-3 required">
											<div class="">
												<label for="name" class="form-label"
													><span
														v-if="personBreakdown.errors.has('pax')"
														class="text-danger text-lowercase"
													>
														{{ personBreakdown.errors.get("pax") }} </span
													><span v-else>Pax</span></label
												>
												<v-text-field
													density="compact"
													variant="outlined"
													rounded="0"
													clearable
													placeholder="No of Tourists"
													v-model="personBreakdown.pax"
													id="pax"
												></v-text-field>
											</div>
										</div>
									</div>
								</div>
							</div>
						</v-card-text>

						<!-- Footer with Action Buttons -->
						<v-card-actions>
							<v-spacer>
								<!-- end of modal body -->
								<div
									class="justify-content-start modal-footer"
									style="font-family: HeaderCustomFont"
								>
									<button
										:disabled="!currentRoute"
										type="submit"
										class="btn bg-green-custom text-white w-10 m-2"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Save
									</button>
									<button
										type="button"
										class="btn bg-danger text-white w-10 m-2"
										@click="closeModal('breakdown')"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Close
									</button>
								</div>
							</v-spacer>
							<!-- <v-btn color="primary" @click="tourModal = false">Close</v-btn> -->
						</v-card-actions>
					</form>
				</v-card>
			</v-dialog>
		</div>
	</content>
</template>

<script>
import config from "../../config/settings.js";
import { Errors, Form } from "vform";

export default {
	components: {},
	data() {
		return {
			api: config.API_URL,
			prefix: config.API_PFX,
			message: "",
			http_code: "",
			user: [],
			messages: [],
			loadModalData: false,
			costData: false,
			pricingModal: false,
			adminModal: false,
			breakdownModal: false,
			infiniteActivities: [],
			infiniteBoats: [],
			infiniteItems: [],
			infiniteLodges: [],
			infiniteFlights: [],
			infiniteParks: [],
			infiniteTours: [],
			infiniteTypes: [],
			infiniteVariations: [],
			infiniteVehicles: [],
			currencyList: [],
			currencyRates: [],
			tourDays: [],
			expectedDays: 0,
			itineraries: [],
			AdminMultiplier: "",
			FirstMultiplier: "",
			SecondMultiplier: "",
			filterCosting: new Form({
				start: null,
				end: null,
				tour: null,
			}),
			tourPricing: new Form({
				id: "",
				tour_id: null,
				tourist_id: "",
				cost_type_id: null,
				cost_item_id: null,
				activity_id: null,
				lodge_id: null,
				boat_id: null,
				park_id: null,
				vehicle_id: null,
				unit_cost: "",
				qty: "",
				days_nights: "",
				total: "",
				cost_detail: "",
				cost_kind: null,
				is_optional: "",
				deleted_at: "",
				created_at: "",
				created_by: "",
				updated_at: "",
				updated_by: "",
			}),
			adminFee: new Form({
				id: "",
				tour_id: "",
				admin_fee: "",
				multiplier: "",
				total_fee: "",
				is_deleted: "",
				deleted_at: "",
				created_by: "",
				created_at: "",
				updated_by: "",
				updated_at: "",
			}),
			personBreakdown: new Form({
				id: "",
				first_amount: "",
				first_diviser: "",
				second_amount: "",
				second_diviser: "",
				pax: "",
				is_deleted: "",
				created_by: "",
				created_at: "",
				updated_by: "",
				updated_at: "",
			}),

			searchPricing: "",
			pricingPerPage: 10,
			pricings: [],
			pricingHeaders: [
				{ title: "#", value: "index", sortable: true },
				{ title: "Category", value: "item", sortable: true },
				{ title: "Price Item", value: "variation", sortable: true },
				{ title: "Unit Cost", value: "unit", sortable: true },
				{ title: "Qty", value: "unit", sortable: true },
				{ title: "Total", value: "unit", sortable: true },
				{ title: "actions", value: "actions", sortable: true },
			],

			searchAdmin: "",
			adminPerPage: 10,
			adminFees: [],
			adminHeaders: [
				{ title: "#", value: "index", sortable: true },
				{ title: "Admin Percentage", value: "admin_fee", sortable: true },
				{ title: "Multiplier", value: "multiplier", sortable: true },
				{ title: "Total", value: "total_fee", sortable: true },
				{ title: "Actions", value: "actions", sortable: true },
			],

			searchBreakdown: "",
			breakdownPerPage: 10,
			personBreakdowns: [],
			breakdownHeaders: [
				{ title: "#", value: "index", sortable: true },
				{
					title: "Transport, Admin Fees",
					value: "first_amount",
					sortable: true,
				},
				{
					title: "Accomodation, Activity Fees",
					value: "second_amount",
					sortable: true,
				},
				{ title: "Total Breakdown", value: "total", sortable: true },
				{ title: "Pax", value: "pax", sortable: true },
				{ title: "Actions", value: "actions", sortable: true },
			],

			openPanels: {
				filterTours: [0],
				tourPricing: [0],
				optionalCosts: [0],
				adminFees: [0],
				personBreakdown: [0],
			},
		};
	},
	methods: {
		getAdminMultiplier() {
			var filteredCosts, total;
			filteredCosts = this.totals.filter(
				(cost) =>
					cost.code === "ACC" || cost.code === "ACT" || cost.code === "TR"
			);
			total = filteredCosts.reduce((sum, cost) => sum + cost.total, 0);
			this.AdminMultiplier = total;
			console.log("Admin Multiplier: " + this.AdminMultiplier);
			// return this.AdminMultiplier;
		},
		getFirstMultiplier() {
			var admin_fees, filteredCosts, total;
			filteredCosts = this.totals.filter((cost) => cost.code === "TR");
			if (this.adminFees && this.adminFees.data && this.adminFees.data[0]) {
				admin_fees = parseInt(this.adminFees.data[0].total_fee);
			} else {
				admin_fees = 0;
			}
			total = filteredCosts.reduce((sum, cost) => sum + cost.total, 0);
			this.FirstMultiplier = total + admin_fees;
			console.log("First Multiplier: " + this.FirstMultiplier);
			// return this.FirstMultiplier;
		},
		getSecondMultiplier() {
			var filteredCosts, total;
			filteredCosts = this.totals.filter(
				(cost) => cost.code === "ACC" || cost.code === "ACT"
			);
			total = filteredCosts.reduce((sum, cost) => sum + cost.total, 0);
			this.SecondMultiplier = total;
			console.log("Second Multiplier: " + this.SecondMultiplier);
			// return this.SecondMultiplier;
		},
		selectItem(item, mode) {
			if (mode == "activity") {
				this.tourPricing.cost_detail = "";
				this.tourPricing.cost_detail = item.title;
				this.tourPricing.vehicle_id = "";
				this.tourPricing.park_id = "";
				this.tourPricing.lodge_id = "";
				this.tourPricing.cost_item_id = "";
			} else if (mode == "vehicle") {
				this.tourPricing.cost_detail = "";
				this.tourPricing.cost_detail = item.vehicle.plate_number;
				this.tourPricing.activity_id = "";
				this.tourPricing.park_id = "";
				this.tourPricing.lodge_id = "";
				this.tourPricing.cost_item_id = "";
			} else if (mode == "lodge") {
				this.tourPricing.cost_detail = "";
				this.tourPricing.cost_detail = item.lodge.name;
				this.tourPricing.vehicle_id = "";
				this.tourPricing.park_id = "";
				this.tourPricing.activity_id = "";
				this.tourPricing.cost_item_id = "";
			} else if (mode == "boat") {
				this.tourPricing.cost_detail = "";
				this.tourPricing.cost_detail = item.boat.name;
				this.tourPricing.vehicle_id = "";
				this.tourPricing.park_id = "";
				this.tourPricing.activity_id = "";
				this.tourPricing.cost_item_id = "";
			} else if (mode == "flight") {
				this.tourPricing.cost_detail = "";
				this.tourPricing.cost_detail = item.flight.name;
				this.tourPricing.vehicle_id = "";
				this.tourPricing.park_id = "";
				this.tourPricing.activity_id = "";
				this.tourPricing.cost_item_id = "";
			} else if (mode == "park") {
				this.tourPricing.cost_detail = "";
				this.tourPricing.cost_detail = item.park.name;
				this.tourPricing.vehicle_id = "";
				this.tourPricing.activity_id = "";
				this.tourPricing.lodge_id = "";
				this.tourPricing.cost_item_id = "";
			} else {
				this.tourPricing.cost_detail = "";
				this.tourPricing.cost_detail = item.name;
				this.tourPricing.vehicle_id = "";
				this.tourPricing.activity_id = "";
				this.tourPricing.lodge_id = "";
				this.tourPricing.park_id = "";
			}
		},
		async selectTour(event) {
			sessionStorage.removeItem("selected_tour");
			sessionStorage.setItem("selected_tour", JSON.stringify(event));
			this.selectedTour = event;
			this.tourPricing.qty = this.selectedTour.pax;
			this.personBreakdown.pax = this.selectedTour.pax;
			this.personBreakdown.first_diviser = this.selectedTour.pax;
			this.showMessage("Tour " + event.reference_number + " selected!");

			await this.managePricing("None", "fetch");
			await this.manageAdmin("None", "fetch");
			await this.manageBreakdown("None", "fetch");
			// await this.manageItinerary();
		},
		async openModal(modal, mode) {
			// Show loading indicator
			this.loadModalData = true;

			try {
				// Lazy load cost modal data only when needed
				if (modal == "pricing" && !this.costData) {
					this.costData = true;
					await Promise.all([
						this.getInfinites("lodges"),
						this.getInfinites("boats"),
						this.getInfinites("flights"),
						this.getInfinites("vehicles"),
						this.getInfinites("parks"),
						this.getInfinites("activities"),

						this.getInfinites("items"),
						this.getInfinites("types"),
						this.getInfinites("currencies"),
						this.getInfinites("currency-rates"),
					]);
				}
			} catch (error) {
				console.error("Error loading modal data:", error);
			} finally {
				// Hide loading indicator
				this.loadModalData = false;
			}

			var user_id = sessionStorage.getItem("user_id");
			if (modal == "pricing") {
				this.tourPricing.tour_id = this.selectedTour.tour_id;
				await this.getInfinites("days");
				await this.getInfinites("expected");
				if (this.expectedDays.data < 1) {
					// this.selectTour(this.selectedTour);
					if (mode == "update") {
						this.tourPricing.updated_by = user_id;
						this.editMode = true;
						this.pricingModal = true;
					} else {
						this.tourPricing.created_by = user_id;
						this.editMode = false;
						this.pricingModal = true;
					}
				} else {
					var focus = this.expectedDays.data > 1 ? " entries" : " entry";
					this.showInfo(
						"Incomplete Itinerary: " +
							this.expectedDays.data +
							focus +
							" required!"
					);
				}
			} else if (modal == "optional") {
				if (mode == "update") {
					this.editMode = true;
					this.optionalModal = true;
				} else {
					this.editMode = false;
					this.optionalModal = true;
				}
			} else if (modal == "admin") {
				this.adminFee.tour_id = this.selectedTour.tour_id;
				this.adminFee.multiplier = this.adminMultiplier;

				if (mode == "update") {
					this.adminFee.updated_by = user_id;
					this.editMode = true;
					this.adminModal = true;
				} else {
					this.adminFee.created_by = user_id;
					this.editMode = false;
					this.adminModal = true;
				}
			} else if (modal == "breakdown") {
				this.personBreakdown.tour_id = this.selectedTour.tour_id;
				this.personBreakdown.first_amount = this.FirstMultiplier;
				this.personBreakdown.second_amount = this.SecondMultiplier;
				if (mode == "update") {
					this.personBreakdown.updated_by = user_id;
					this.editMode = true;
					this.breakdownModal = true;
				} else {
					this.personBreakdown.created_by = user_id;
					this.editMode = false;
					this.breakdownModal = true;
				}
			}
		},
		closeModal(modal) {
			if (modal == "pricing") {
				this.editMode = false;
				this.pricingModal = false;
				this.tourPricing.reset();
				this.tourPricing.errors.clear();
			} else if (modal == "optional") {
				this.editMode = false;
				this.optionalModal = false;
			} else if (modal == "admin") {
				this.editMode = false;
				this.adminModal = false;
				this.adminFee.reset();
				this.adminFee.errors.clear();
			} else if (modal == "breakdown") {
				this.editMode = false;
				this.breakdownModal = false;
				this.personBreakdown.reset();
				this.personBreakdown.errors.clear();
			}
		},
		async getInfinites(mode) {
			var query, api;
			if (mode == "tours") {
				api = this.api + this.prefix + "/reservation/tours";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteTours = [];
					this.infiniteTours = query.response;
				} else {
					this.showInfo(this.message, this.http_code);
				}
			} else if (mode == "items") {
				api = this.api + this.prefix + "/masters/costitem";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteItems = [];
					this.infiniteItems = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "types") {
				api = this.api + this.prefix + "/masters/costtype";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteTypes = [];
					this.infiniteTypes = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "parks") {
				api =
					this.api +
					this.prefix +
					"/reservation/park/" +
					this.selectedTour.tour_id;
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteParks = [];
					this.infiniteParks = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "flights") {
				api =
					this.api +
					this.prefix +
					"/reservation/flight/" +
					this.selectedTour.tour_id;
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteFlights = [];
					this.infiniteFlights = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "lodges") {
				api =
					this.api +
					this.prefix +
					"/reservation/accomodation/" +
					this.selectedTour.tour_id;
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteLodges = [];
					this.infiniteLodges = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "boats") {
				api =
					this.api +
					this.prefix +
					"/reservation/boat/" +
					this.selectedTour.tour_id;
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.infiniteBoats = [];
					this.infiniteBoats = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "activities") {
				api =
					this.api +
					this.prefix +
					"/reservation/itineraryz/" +
					this.selectedTour.tour_id;
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteActivities = [];
					this.infiniteActivities = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "vehicles") {
				api =
					this.api +
					this.prefix +
					"/reservation/vehicle/" +
					this.selectedTour.tour_id;
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteVehicles = [];
					this.infiniteVehicles = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "days") {
				api =
					this.api +
					this.prefix +
					"/reservation/tour/" +
					this.selectedTour.tour_id +
					"/days";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.tourDays = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "expected") {
				api =
					this.api +
					this.prefix +
					"/reservation/itinerary/" +
					this.selectedTour.tour_id +
					"/expected";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.expectedDays = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "currencies") {
				api = this.api + this.prefix + "/masters/currencies";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.currencyList = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "currency-rates") {
				api = this.api + this.prefix + "/masters/currency-rates";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.currencyRates = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			}
		},
		async getTotalCosts(event, mode) {
			var query, api;
			if (mode == "fetch") {
				if (this.selectedTour !== null) {
					api =
						this.api +
						this.prefix +
						"/reservation/totals/" +
						this.selectedTour.tour_id;
					query = await this.getData(api);
					this.message = query.response.message;
					this.http_code = query.code;
					if (query.result == "success") {
						// perform other actions
						this.totals = [];
						this.totals = query.response;
					} else {
						this.showError(this.message, this.http_code);
					}
				}
			}
		},
		async managePricing(event, mode) {
			var query, api;
			if (mode == "fetch") {
				if (this.selectedTour !== null) {
					api =
						this.api +
						this.prefix +
						"/finance/costs/" +
						this.selectedTour.tour_id;
					query = await this.getData(api);
					this.message = query.response.message;
					this.http_code = query.code;
					if (query.result == "success") {
						// perform other actions
						this.pricings = [];
						this.pricings = query.response;
						await this.getTotalCosts("None", "fetch");
						this.getAdminMultiplier();
					} else {
						this.showError(this.message, this.http_code);
					}
				}
			} else if (mode == "insert") {
				api = this.api + this.prefix + "/finance/costs";
				query = await this.postData(api, this.tourPricing);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.showMessage(this.message);
					this.closeModal("pricing");
					this.managePricing("None", "fetch");
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "update") {
				api = this.api + this.prefix + "/finance/costs/" + event.id;
				query = await this.putData(api, this.tourPricing);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.showMessage(this.message);
					this.closeModal("pricing");
					this.managePricing("None", "fetch");
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "edit") {
				this.tourPricing.reset();
				console.log(event);
				this.tourPricing.fill(event);
				this.tourPricing.cost_type_id = event.type;
				this.tourPricing.park_id = event.park;
				this.tourPricing.boat_id = event.boat;
				this.tourPricing.lodge_id = event.lodge;
				this.tourPricing.activity_id = event.activity;
				this.tourPricing.vehicle_id = event.vehicle;
				this.tourPricing.cost_item_id = event.item;
				this.tourPricing.currency =
					this.currencyList.data?.find(
						(item) => item.symbol === event.currency
					) || event.currency;
				this.openModal("pricing", "update");
			} else {
				let confirmation = await this.showConfirmation("Delete this Cost?");
				if (confirmation.result == "Yes") {
					api = this.api + this.prefix + "/finance/costs/" + event.id;
					query = await this.deleteData(api);
					this.message = query.response.message;
					this.http_code = query.code;
					if (query.result == "success") {
						this.showMessage(this.message);
						this.closeModal("pricing");
						this.managePricing("None", "fetch");
					} else {
						this.showError(this.message, this.http_code);
					}
				}
			}
		},
		async manageAdmin(event, mode) {
			var query, api;
			if (mode == "fetch") {
				if (this.selectedTour !== null) {
					// tour = JSON.parse(sessionStorage.getItem("selected_tour"));
					api =
						this.api +
						this.prefix +
						"/finance/costadmin/" +
						this.selectedTour.tour_id;
					query = await this.getData(api);
					this.message = query.response.message;
					this.http_code = query.code;
					if (query.result == "success") {
						this.adminFees = [];
						this.adminFees = query.response;
						this.getFirstMultiplier();
						this.getSecondMultiplier();
					} else {
						this.showError(this.message, this.http_code);
					}
				}
			} else if (mode == "insert") {
				api = this.api + this.prefix + "/finance/costadmin";
				query = await this.postData(api, this.adminFee);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.showMessage(this.message);
					this.closeModal("admin");
					this.manageAdmin("None", "fetch");
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "update") {
				api = this.api + this.prefix + "/finance/costadmin/" + event.id;
				query = await this.putData(api, this.adminFee);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.showMessage(this.message);
					this.closeModal("admin");
					this.manageAdmin("None", "fetch");
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "edit") {
				this.adminFee.reset();
				console.log(event);
				this.adminFee.fill(event);
				this.openModal("admin", "update");
			} else {
				let confirmation = await this.showConfirmation("Delete this Cost?");
				if (confirmation.result == "Yes") {
					api = this.api + this.prefix + "/finance/costadmin/" + event.id;
					query = await this.deleteData(api);
					this.message = query.response.message;
					this.http_code = query.code;
					if (query.result == "success") {
						this.showMessage(this.message);
						this.closeModal("admin");
						this.manageAdmin("None", "fetch");
					} else {
						this.showError(this.message, this.http_code);
					}
				}
			}
		},
		async manageBreakdown(event, mode) {
			var query, api;
			if (mode == "fetch") {
				if (this.selectedTour !== null) {
					// tour = JSON.parse(sessionStorage.getItem("selected_tour"));
					api =
						this.api +
						this.prefix +
						"/finance/costbreak/" +
						this.selectedTour.tour_id;
					query = await this.getData(api);
					this.message = query.response.message;
					this.http_code = query.code;
					if (query.result == "success") {
						this.personBreakdowns = [];
						this.personBreakdowns = query.response;
					} else {
						this.showError(this.message, this.http_code);
					}
				}
			} else if (mode == "insert") {
				api = this.api + this.prefix + "/finance/costbreak";
				query = await this.postData(api, this.personBreakdown);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.showMessage(this.message);
					this.closeModal("breakdown");
					this.manageBreakdown("None", "fetch");
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "update") {
				api = this.api + this.prefix + "/finance/costbreak/" + event.id;
				query = await this.putData(api, this.personBreakdown);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.showMessage(this.message);
					this.closeModal("breakdown");
					this.manageBreakdown("None", "fetch");
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "edit") {
				this.personBreakdown.reset();
				this.personBreakdown.fill(event);
				this.openModal("breakdown", "update");
			} else {
				let confirmation = await this.showConfirmation(
					"Delete this Breakdown?"
				);
				if (confirmation.result == "Yes") {
					api = this.api + this.prefix + "/finance/costbreak/" + event.id;
					query = await this.deleteData(api);
					this.message = query.response.message;
					this.http_code = query.code;
					if (query.result == "success") {
						this.showMessage(this.message);
						this.closeModal("breakdown");
						this.manageBreakdown("None", "fetch");
					} else {
						this.showError(this.message, this.http_code);
					}
				}
			}
		},
		async manageOptional(event, mode) {
			var query, api;
			if (mode == "fetch") {
				if (this.selectedTour !== null) {
					// tour = JSON.parse(sessionStorage.getItem("selected_tour"));
					api = this.api + "/costoption/" + this.selectedTour.id;
					query = await this.getData(api);
					this.message = query.response.message;
					this.http_code = query.code;
					if (query.result == "success") {
						// perform other actions
					} else {
						this.showError(this.message, this.http_code);
					}
				}
			} else if (mode == "insert") {
				api = this.api + "/costoption";
				query = this.postData(api, this.tourPricing);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "update") {
				api = this.api + "/costoption/" + event.id;
				query = this.putData(api, this.tourPricing);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "edit") {
				this.optionalCosts.reset();
				console.log(event);
				this.optionalCosts.fill(event);
				this.openModal("pricing", "update");
			} else {
				api = this.api + "/costoption/" + event.id;
				query = this.deleteData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
				} else {
					this.showError(this.message, this.http_code);
				}
			}
		},
		async manageItinerary() {
			var query, api;
			if (this.selectedTour !== null) {
				// tour = JSON.parse(sessionStorage.getItem("selected_tour"));
				api =
					this.api +
					this.prefix +
					"/reservation/itineraries/" +
					this.selectedTour.tour_id;
				query = await this.getData(api);
				this.message = this.capitalizeWords(query.response.message);
				this.http_code = query.code;
				this.itineraries = [];
				if (query.result == "success" && query.response.data.length > 0) {
					this.itineraries = query.response;
				}
			}
		},
	},
	computed: {
		currentRoute() {
			return this.$route.path.includes("/reservations/");
		},
		adminMultiplier() {
			const filteredCosts = this.totals.filter(
				(cost) =>
					cost.code === "ACC" || cost.code === "ACT" || cost.code === "TR"
			);
			const total = filteredCosts.reduce((sum, cost) => sum + cost.total, 0);
			this.AdminMultiplier = total;
			return this.AdminMultiplier;
		},
		firstMultiplier() {
			const filteredCosts = this.totals.filter((cost) => cost.code === "TR");
			if (this.adminFees && this.adminFees.data.length > 0) {
				const admin_fees = this.adminFees[0].total_fee;
				console.log(admin_fees);
			} else {
				const admin_fees = 0;
			}
			const total = filteredCosts.reduce((sum, cost) => sum + cost.total, 0);
			this.FirstMultiplier = total + admin_fees;
			return this.FirstMultiplier;
		},
		secondMultiplier() {
			const filteredCosts = this.totals.filter(
				(cost) => cost.code === "ACC" || cost.code === "ACT"
			);
			const total = filteredCosts.reduce((sum, cost) => sum + cost.total, 0);
			this.SecondMultiplier = total;
			return this.SecondMultiplier;
		},
		tourSelect() {
			return (item) => {
				if (item && item.reference_number && item.client && item.agent_name) {
					return (
						item.reference_number + " (" + item.client + ") " + item.agent_name
					);
				}
			};
		},
		truncateTitle() {
			return {
				contentClass: "truncate-title",
			};
		},
	},
	async created() {
		await this.getInfinites("tours");

		if (this.selectedTour == null) {
			if (sessionStorage.getItem("selected_tour") !== "") {
				let selected = JSON.parse(sessionStorage.getItem("selected_tour"));
				this.selectedTour = selected;
				this.filterCosting.tour = this.selectedTour;
				this.selectTour(selected);
			}
		}
	},
	beforeMount() {},
	mounted() {},
	unmounted() {},
	beforeUnmount() {},
};
</script>



